exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".px3h7p_eNGs6Mp{display:flex;margin:16px 0 12px}.px3h7p_eNGs6Mp input{flex-grow:1;margin:0;width:0}.px3h7p_eNGs6Mp input:focus{background:#fff;border:none;box-shadow:inset 0 0 0 2px #0079bf}.px3h7p_eNGs6Mp button{height:32px;margin:0;margin-left:8px}", ""]);

// exports
exports.locals = {
	"shareLinkContainer": "px3h7p_eNGs6Mp"
};